// src/components/Promos/AnnualDonatePopup.jsx
import React from "react";

export default function AnnualDonatePopup({
  open = false,
  onClose,
  title = "Soutenir ce projet",
  children,
}) {
  if (!open) return null;

  return (
    <div className="promo-modal-overlay" role="dialog" aria-modal="true">
      <div className="promo-modal">
        {/* ✅ Bande bleue réelle (impossible à cacher) */}
        <div className="promo-top-strip" aria-hidden="true" />

        <div className="promo-modal-header">
          <h2 className="promo-modal-title">{title}</h2>

          <button
            type="button"
            className="promo-modal-close"
            onClick={onClose}
            aria-label="Fermer"
            title="Fermer"
          >
            ✕
          </button>
        </div>

        <div className="promo-modal-body">{children}</div>
      </div>
    </div>
  );
}
